module.exports = __webpack_public_path__ + "img/LaoNianBing.2ff44ccb.png";